module.exports = __webpack_public_path__ + "img/img03.df136711.svg";